/**
 * @generated SignedSource<<85f0c75bb6fc321ff7a0441f8312f747>>
 * @lightSyntaxTransform
 * @nogrep
 */
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
import { ConcreteRequest } from 'relay-runtime';

export type ConfirmationPageLandlineMutation$variables = {
  creditApplicationId: string;
};
export type ConfirmationPageLandlineMutation$data = {
  readonly fraudAlertChallengeManualReview: {
    readonly success: boolean;
  };
};
export type ConfirmationPageLandlineMutation = {
  response: ConfirmationPageLandlineMutation$data;
  variables: ConfirmationPageLandlineMutation$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'creditApplicationId',
      },
    ],
    v1 = [
      {
        alias: null,
        args: [
          {
            fields: [
              {
                kind: 'Variable',
                name: 'creditApplicationId',
                variableName: 'creditApplicationId',
              },
            ],
            kind: 'ObjectValue',
            name: 'q',
          },
        ],
        concreteType: 'FraudAlertChallengeManualReviewResponse',
        kind: 'LinkedField',
        name: 'fraudAlertChallengeManualReview',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'success',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Fragment',
      metadata: null,
      name: 'ConfirmationPageLandlineMutation',
      selections: v1 /*: any*/,
      type: 'Mutation',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Operation',
      name: 'ConfirmationPageLandlineMutation',
      selections: v1 /*: any*/,
    },
    params: {
      cacheID: '842feb23a8f7415ce727de1bbe62767d',
      id: null,
      metadata: {},
      name: 'ConfirmationPageLandlineMutation',
      operationKind: 'mutation',
      text: 'mutation ConfirmationPageLandlineMutation(\n  $creditApplicationId: String!\n) {\n  fraudAlertChallengeManualReview(q: {creditApplicationId: $creditApplicationId}) {\n    success\n  }\n}\n',
    },
  };
})();

(node as any).hash = 'f28f80e3fa311571584e78eed9ecd19b';

export default node;
